export enum LogLevel {
  Info = 'info',
  Debug = 'debug',
  Warn = 'warn',
  Error = 'error',
}



// WEBPACK FOOTER //
// ./src/app/services/logging/log-level.enum.ts